//
// --- Types ---

export type CompanyKeyTypeKey = keyof typeof COMPANY_KEY;
export type CompanyKeyType = typeof COMPANY_KEY[CompanyKeyTypeKey];

// Other Company Types

/** A generic company interface */
export interface MasterCompanyType {
  companyKey: number;
}

// cSpell:disable
export interface CompanyType {
  adminComments: string;
  companyKey: number;
  companyName: string;
  companyStatusCode: string;
  companyType: string;
  creationTime: number; // timestamp
  displayName: string;
  domainObjectDescrKey: number;
  domainObjectKey: number;
  dunns: string;
  evaluationScore: number; // decimal
  fieldMap: {};
  idpEntityId: string;
  masterCompany: MasterCompanyType;
  ownercompanykey: number;
  ownerCompanyKey: number;
  ownerpersonkey: number;
  ownerPersonKey: number;
  revenue1: number; // decimal
  revenue1Yr: number;
  revenue2: number; // decimal
  revenue2Yr: number;
  updatedByUserKey: number;
  updateSearchIndex: string;
  updateTime: number; // timestamp
  website: string;
}
// cSpell:enable

//
// --- Constants ---

export const COMPANY_KEY = {
  POWERADVOCATE: 2041
} as const;
